<template>
  <div class="w100p display-flex justify-center align-center" :class="loaderClasses">
    <v-progress-circular :width="width" :color="color" indeterminate :size="size" />
  </div>
</template>

<script>
export default {
  name: 'bh-loader',
  props: {
    width: {
      type: String | Number,
      default: 3
    },
    color: {
      type: String,
      default: '#7857b3'
    },
    loaderClasses: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 32
    }
  }
}
</script>
